module.exports = __webpack_public_path__ + "static/img/ice_hockey.a92cd18.jpg";